/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-danger */
import { useEffect } from "react";
import parse from "html-react-parser";

export default function FlightRouteDT(props) {
  useEffect(() => {
    if (language && language === "ar") document.body.classList.add("isArabic");
  });
  const { language, initial_js: initialJS = "", main_div: mainDiv, top_overlay, ccde } = props?.data || {};
  const googletTagString = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-NWV3K7C');
`;

  return (
    <>
      {initialJS && initialJS !== "" ? parse(initialJS) : null}
      <div dangerouslySetInnerHTML={{ __html: mainDiv }} />
      <div dangerouslySetInnerHTML={{ __html: top_overlay }} />
      {ccde && (ccde === "" || ccde === "in" || ccde === "IN") ? (
        <script dangerouslySetInnerHTML={{ __html: googletTagString }} />
      ) : null}
    </>
  );
}
